import Constants from '../common/constants';

const { ReduxAction } = Constants;

const loyaltyProgramSelected = (dispatch, data) => {
  dispatch({
    type:    ReduxAction.LoyaltyProgramSelected,
    payload: data,
  });
};

const loyaltyProgramDataUpdate = (dispatch, data) => {
  dispatch({
    type:    ReduxAction.LoyaltyProgramDataUpdate,
    payload: data,
  });
};

const updateLoyaltyTab = (dispatch, tab) => {
  dispatch({
    type:    ReduxAction.LoyaltyTabUpdate,
    payload: tab,
  });
};

const startSavingLC = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramStartSaving,
  });
};

const finishSavingLC = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramFinishSaving,
  });
};

const hideLCSaveBtn = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramSaveBtnHide,
  });
};

const showLCSaveBtn = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramSaveBtnShow,
  });
};

const enableSaveBtn = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramEnableSaveBtn,
  });
};

const disableSaveBtn = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramDisableSaveBtn,
  });
};

const showAdvancedStatusBtn = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramShowAdvancedStatusBtn,
  });
};

const hideAdvancedStatusBtn = (dispatch) => {
  dispatch({
    type: ReduxAction.LoyaltyProgramHideAdvancedStatusBtn,
  });
};

const loyaltyAction = {
  loyaltyProgramSelected,
  loyaltyProgramDataUpdate,
  updateLoyaltyTab,
  startSavingLC,
  finishSavingLC,
  hideLCSaveBtn,
  showLCSaveBtn,
  enableSaveBtn,
  disableSaveBtn,
  showAdvancedStatusBtn,
  hideAdvancedStatusBtn,
};

export default loyaltyAction;
